module.exports = __webpack_public_path__ + "static/media/SourceHanSerifCN-Regular.74a79dd1.svg";